var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex align-center"},[_c('div',{class:{
      'square-legend': true,
      'square-legend--border': _vm.bordered,
    },style:(("background-color: " + _vm.backgroundColor))}),_c('span',{staticClass:"ml-3"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }